import React from 'react';
import { useThemeSettings } from '../../hooks/useThemeSettings';
import { useDesignColors } from '../../hooks/useDesignColors';

export function TypingIndicator() {
  const { theme } = useThemeSettings();
  const { colors } = useDesignColors();
  const isDark = theme.mode === 'dark';

  return (
    <div className={`flex items-center gap-3 my-6 pr-6 md:pr-12`}>
      <div className="w-6 h-6 rounded-lg overflow-hidden flex items-center justify-center shrink-0"
        style={{
          background: `${colors.gradientStart}1a`,
        }}>
        <div className="w-4 h-4" style={{ color: colors.gradientStart }}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 14s1.5 2 4 2 4-2 4-2" />
            <line x1="9" y1="9" x2="9.01" y2="9" />
            <line x1="15" y1="9" x2="15.01" y2="9" />
          </svg>
        </div>
      </div>
      
      <div className={`rounded-lg px-4 py-3 max-w-[90%] md:max-w-[80%] ${
        isDark 
          ? 'bg-gray-800/95 text-gray-200' 
          : 'bg-gray-100 text-gray-900'
      }`}>
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 rounded-full bg-indigo-400 animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 rounded-full bg-indigo-400 animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 rounded-full bg-indigo-400 animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
}